import React from "react";
import { useMxFieldControllerContext } from "../../../../context/MxFieldController";
import MxInputNumberField, {
  MxInputNumberFieldProps
} from "@rf-l1/form/text-fields/MxInputNumberField";

type omit = "name" | "onChange";
export type MxFormTextNumberFieldProps = Omit<MxInputNumberFieldProps, omit>
const MxFormTextNumberField = (props: MxFormTextNumberFieldProps) => {
  const { onChange, onBlur, name, value, invalid, id,required } =
    useMxFieldControllerContext();
    
  return (
    <MxInputNumberField
      {...props}
      id={id}
      onChange={onChange}
      onBlur={onBlur}
      name={name}
      value={value}
      error={invalid}
      required={required}
    />
  );
};

export default MxFormTextNumberField;
